export default __webpack_public_path__ + "images/icono-app.9c1b62958b571a657bf295b41a989458.svg";